import React, { useState, useEffect } from 'react'
import Layout from '../../../Components/Layout'
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import Breadcrumb from '../Component/Breadcrumb';
import Sidebar from '../../Dashboard/Component/Siderbar';
import { Formik, Form } from 'formik';
import InputMask from 'react-input-mask';
import { agencyValidationSchema } from './validationSchema';
import AddressForm from './Components/AddressForm';
import config from '../../../config';

export default function Edit() {
    const navigate = useNavigate();
    const [bankStates, setBankStates] = useState([]);
    const [bankCities, setBankCities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [countries, setCountries] = useState([]);
    const [agencyId, setAgencyId] = useState();
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [billingStates, setBillingStates] = useState([]);
    const [billingCities, setBillingCities] = useState([]);
    const [shippingStates, setShippingStates] = useState([]);
    const [shippingCities, setShippingCities] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [isOwner, setIsOwner] = useState(false);
    const [formInitialValues, setFormInitialValues] = useState({
        name: "",
        email: "",
        phone: "",
        description: "",
        details: {
            commercial_name: "",
            iban_number: "",
            account_number: "",
            swift_code: "",
            tax_id_number: "",
            bank_country_id: "",
            bank_state_id: "",
            currency: "EUR",
        },
        address: {
            address: "",
            country_id: "",
            state_id: "",
            city_id: "",
            zip_code: "",
        },
        image: null
    });

    const fetchCountries = async () => {
        try {
            const response = await axios.get(`${config.API_BASE_URL}geo/countries`);
            setCountries(response.data);
        } catch (err) {
            console.error('Error fetching countries:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch countries',
            });
        }
    };
  
    const fetchStates = async (type, countryId) => {
        if (!countryId) return;
        try {
            const response = await axios.get(`${config.API_BASE_URL}geo/states/${countryId}`);
            switch (type) {
                case 'billing':
                    setBillingStates(response.data);
                    break;
                case 'shipping':
                    setShippingStates(response.data);
                    break;
                case 'bank':
                    setBankStates(response.data);
                    break;
                default:
                    setStates(response.data);
                    break;
            }
        } catch (err) {
            console.error('Error fetching states:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch states',
            });
        }
    };
    
    const fetchCities = async (type, stateId) => {
        if (!stateId) return;   
        try {
            const response = await axios.get(`${config.API_BASE_URL}geo/cities/${stateId}`);
            switch (type) {
                case 'billing':
                    setBillingCities(response.data);
                    break;
                case 'shipping':
                    setShippingCities(response.data);
                    break;
                default:
                    setCities(response.data);
                    break;
            }
        } catch (err) {
            console.error('Error fetching cities:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch cities',
            });
        }
    };

    const fetchAgencyDetails = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${config.API_BASE_URL_V1}agency/detail`,
                {
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                    },
                }
            );
            const agencyDetail = response.data.data;
            console.log('agencyDetail :',agencyDetail)
            
            setFormInitialValues({
                name: agencyDetail.name || "",
                email: agencyDetail.email || "",
                phone: agencyDetail.phone || "",
                description: agencyDetail.description || "",
                details: {
                    commercial_name: agencyDetail.details?.commercial_name || "",
                    iban_number: agencyDetail.details?.iban_number || "",
                    account_number: agencyDetail.details?.account_number || "",
                    swift_code: agencyDetail.details?.swift_code || "",
                    tax_id_number: agencyDetail.details?.tax_id_number || "",
                    bank_country_id: agencyDetail.details?.bank_country_id || "",
                    bank_state_id: agencyDetail.details?.bank_state_id || "",
                    currency: agencyDetail.details?.currency || "EUR",
                },
                address: {
                    address: agencyDetail.address?.address || "",
                    country_id: agencyDetail.address?.country_id || "",
                    state_id: agencyDetail.address?.state_id || "",
                    city_id: agencyDetail.address?.city_id || "",
                    zip_code: agencyDetail.address?.zip_code || "",
                },
                image: agencyDetail.image || null,
            });
            
            if (agencyDetail?.image) {
                setPreviewImage(agencyDetail.image);
            }

            // Ana adres için state ve city verilerini yükle
            if (agencyDetail.address?.country_id) {
                fetchStates('main', agencyDetail.address.country_id);
            }
            if (agencyDetail.address?.state_id) {
                fetchCities('main', agencyDetail.address.state_id);
            }

            // Banka detayları için state ve city verilerini yükle
            if (agencyDetail.details?.bank_country_id) {
                fetchStates('bank', agencyDetail.details.bank_country_id);
            }

            // Fatura adresi için state ve city verilerini yükle
            if (agencyDetail.address?.country_id) {
                fetchStates('billing', agencyDetail.address.country_id);
            }
            if (agencyDetail.address?.state_id) {
                fetchCities('billing', agencyDetail.address.state_id);
            }

            // Kargo adresi için state ve city verilerini yükle
            if (agencyDetail.address?.country_id) {
                fetchStates('shipping', agencyDetail.address.country_id);
            }
            if (agencyDetail.address?.state_id) {
                fetchCities('shipping', agencyDetail.address.state_id);
            }

        } catch (error) {
            console.error("Error fetching agency details:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch agency details',
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if(userData.user.isOwner == true)
        {
            setIsOwner(true);
        }else{
            setIsOwner(false);
        }
        fetchCountries();
        fetchAgencyDetails();
    }, []);

    const handleSubmit = async (values, { setSubmitting }) => {
        setLoading(true);
        try {
            const formData = new FormData();

            // Append all form fields except image
            Object.keys(values).forEach(key => {
                if (key === 'address' || key === 'details') {
                    Object.keys(values[key]).forEach(subKey => {
                        formData.append(`${key}[${subKey}]`, values[key][subKey]);
                    });
                } else if (key !== 'image') {
                    formData.append(key, values[key]);
                }
            });

            if (values.image instanceof File) {
                formData.append('image', values.image);
            }

            const response = await axios.post(
                `${config.API_BASE_URL_V1}agency/update`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            if (response.data.status === "success") {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    timerProgressBar: true,
                    timer: 1500,
                    icon: "success",
                    title: "Successfully updated!",
                    showConfirmButton: false,
                });
                fetchAgencyDetails(); // Güncel verileri yükle
            } else {
                throw new Error(response.data.message || 'Update failed');
            }
        } catch (error) {
            console.error("Error updating agency:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.response?.data?.message || "An unexpected error occurred",
            });
        } finally {
            setLoading(false);
            setSubmitting(false);
            window.scrollTo(0, 0);
        }
    };
    
    if(loading)
    {
        return (
        <div id="loader-wrapper">
            <div id="loader">
                <span className="loader-line"></span>
            </div>
        </div>
        )
    }

return (
    <Layout>
        <Breadcrumb title="Company Settings" />
        <div className="content">
            <div className="container">
                <div className="row">
                    <Sidebar>
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <Formik
                                            initialValues={formInitialValues}
                                            onSubmit={handleSubmit}
                                            enableReinitialize={true}
                                        >
                                            {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                                                <Form>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="card-header bg-primary py-3">
                                                                <h5 className="fs-18 mb-0 text-white">Company Information</h5>
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div style={{ 
                                                                border: 'solid', 
                                                                borderColor: 'lightgray', 
                                                                padding: '30px', 
                                                                marginBottom: '10px' 
                                                            }}>
                                                                <div className="col-lg-12 mb-4">
                                                                    <div className="form-group">
                                                                        <label>Company Name</label>
                                                                        <input
                                                                            type="text"
                                                                            name="name"
                                                                            className={`form-control ${touched.name && errors.name ? 'is-invalid' : ''}`}
                                                                            value={values.name}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            disabled={!isOwner}
                                                                        />
                                                                        {touched.name && errors.name && (
                                                                            <div className="invalid-feedback">{errors.name}</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12 row">
                                                                    <div className="col-lg-6 mb-4">
                                                                        <div className="form-group">
                                                                            <label>Email</label>
                                                                            <input
                                                                                type="email"
                                                                                name="email"
                                                                                className={`form-control ${touched.email && errors.email ? 'is-invalid' : ''}`}
                                                                                value={values.email}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                disabled={!isOwner}
                                                                            />
                                                                            {touched.email && errors.email && (
                                                                                <div className="invalid-feedback">{errors.email}</div>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-lg-6 mb-4">
                                                                        <div className="form-group">
                                                                            <label>Phone</label>
                                                                            <InputMask
                                                                                mask="+99 999 999 99 99"
                                                                                name="phone"
                                                                                className={`form-control ${touched.phone && errors.phone ? 'is-invalid' : ''}`}
                                                                                value={values.phone}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                disabled={!isOwner}
                                                                            />
                                                                            {touched.phone && errors.phone && (
                                                                                <div className="invalid-feedback">{errors.phone}</div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-12 mb-4">
                                                                    <div className="form-group">
                                                                        <label>Description</label>
                                                                        <textarea
                                                                            name="description"
                                                                            className={`form-control ${touched.description && errors.description ? 'is-invalid' : ''}`}
                                                                            value={values.description}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            rows="4"
                                                                            disabled={!isOwner}
                                                                        />
                                                                        {touched.description && errors.description && (
                                                                            <div className="invalid-feedback">{errors.description}</div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-12">
                                                                    <div className="form-group">
                                                                        <label>Logo</label>
                                                                        <input
                                                                            type="file"
                                                                            name="image"
                                                                            className="form-control"
                                                                            onChange={(event) => {
                                                                                setFieldValue("image", event.currentTarget.files[0]);
                                                                                if (event.currentTarget.files[0]) {
                                                                                    setPreviewImage(URL.createObjectURL(event.currentTarget.files[0]));
                                                                                }
                                                                            }}
                                                                            disabled={!isOwner}
                                                                        />
                                                                        {previewImage && (
                                                                            <img
                                                                                src={previewImage}
                                                                                alt="Preview"
                                                                                style={{ maxWidth: '200px', marginTop: '10px' }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12">
                                                                <div className="card-header bg-primary py-3">
                                                                    <h5 className="fs-18 mb-0 text-white">Commercial Address</h5>
                                                                </div>
                                                            </div>
                                                            <AddressForm
                                                                countries={countries}
                                                                states={states}
                                                                cities={cities}
                                                                fetchStates={fetchStates}
                                                                fetchCities={fetchCities}
                                                                isOwner={isOwner}
                                                            />

                                                            <div className="col-12">
                                                                <div className="card-header bg-primary py-3">
                                                                    <h5 className="fs-18 mb-0 text-white">Bank Details</h5>
                                                                </div>
                                                            </div>
                                                            <div style={{ 
                                                                border: 'solid', 
                                                                borderColor: 'lightgray', 
                                                                padding: '30px', 
                                                                marginBottom: '10px' 
                                                            }}>
                                                                
                                                                <div className="row mb-4">
                                                                    <div className="col-md-12">
                                                                        <label htmlFor="commercial_name" className='form-label'>Company Commercial Name</label>
                                                                        <input 
                                                                            id="commercial_name"
                                                                            value={values.details.commercial_name} 
                                                                            onChange={handleChange} 
                                                                            onBlur={handleBlur} 
                                                                            type="text" 
                                                                            className={`form-control ${touched.details?.commercial_name && errors.details?.commercial_name ? 'is-invalid' : ''}`}
                                                                            name="details.commercial_name" 
                                                                        />
                                                                        {touched.details?.commercial_name && errors.details?.commercial_name && (
                                                                            <div className="invalid-feedback">{errors.details.commercial_name}</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="iban_number" className="form-label">IBAN Number</label>
                                                                        <InputMask 
                                                                            mask="9999 9999 9999 9999 9999 9999"
                                                                            maskChar="_"
                                                                            id="iban_number"
                                                                            value={values.details.iban_number} 
                                                                            onChange={handleChange} 
                                                                            onBlur={handleBlur} 
                                                                            type="text" 
                                                                            className={`form-control ${touched.details?.iban_number && errors.details?.iban_number ? 'is-invalid' : ''}`}
                                                                            name="details.iban_number" 
                                                                            disabled={!isOwner}
                                                                        />
                                                                        {touched.details?.iban_number && errors.details?.iban_number && (
                                                                            <div className="invalid-feedback">{errors.details.iban_number}</div>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="account_number" className="form-label">Account Number</label>
                                                                        <input 
                                                                            id="account_number"
                                                                            value={values.details.account_number} 
                                                                            onChange={handleChange} 
                                                                            onBlur={handleBlur} 
                                                                            type="text" 
                                                                            className={`form-control ${touched.details?.account_number && errors.details?.account_number ? 'is-invalid' : ''}`}
                                                                            name="details.account_number" 
                                                                            disabled={!isOwner}
                                                                        />
                                                                        {touched.details?.account_number && errors.details?.account_number && (
                                                                            <div className="invalid-feedback">{errors.details.account_number}</div>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="swift_code" className="form-label">Swift Code</label>
                                                                        <input 
                                                                            id="swift_code"
                                                                            value={values.details.swift_code} 
                                                                            onChange={handleChange} 
                                                                            onBlur={handleBlur} 
                                                                            type="text" 
                                                                            className={`form-control ${touched.details?.swift_code && errors.details?.swift_code ? 'is-invalid' : ''}`}
                                                                            name="details.swift_code" 
                                                                            disabled={!isOwner}
                                                                        />
                                                                        {touched.details?.swift_code && errors.details?.swift_code && (
                                                                            <div className="invalid-feedback">{errors.details.swift_code}</div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className="row">
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="tax_id_number" className="form-label">TAX ID Number</label>
                                                                        <input 
                                                                            id="tax_id_number"
                                                                            value={values.details.tax_id_number} 
                                                                            onChange={handleChange} 
                                                                            onBlur={handleBlur} 
                                                                            type="text" 
                                                                            className={`form-control ${touched.details?.tax_id_number && errors.details?.tax_id_number ? 'is-invalid' : ''}`}
                                                                            name="details.tax_id_number" 
                                                                            disabled={!isOwner}
                                                                        />
                                                                        {touched.details?.tax_id_number && errors.details?.tax_id_number && (
                                                                            <div className="invalid-feedback">{errors.details.tax_id_number}</div>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="currency" className="form-label">Currency</label>
                                                                        <select
                                                                            id="currency"
                                                                            name="details.currency"
                                                                            value={values.details.currency}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            disabled={!isOwner}
                                                                            className={`form-control ${touched.details?.currency && errors.details?.currency ? 'is-invalid' : ''}`}
                                                                        >
                                                                            <option value="EUR">EUR (€)</option>
                                                                            <option value="USD">USD ($)</option>
                                                                        </select>
                                                                        {touched.details?.currency && errors.details?.currency && (
                                                                            <div className="invalid-feedback">{errors.details.currency}</div>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="bank_country_id" className="form-label">Country</label>
                                                                        <select 
                                                                            id="bank_country_id"
                                                                            name="details.bank_country_id" 
                                                                            onChange={(e) => {
                                                                                handleChange(e);
                                                                                fetchStates('bank', e.target.value);
                                                                                setFieldValue('details.bank_state_id', '');
                                                                            }} 
                                                                            onBlur={handleBlur} 
                                                                            value={values.details.bank_country_id} 
                                                                            className={`form-control ${touched.details?.bank_country_id && errors.details?.bank_country_id ? 'is-invalid' : ''}`}
                                                                            disabled={!isOwner}
                                                                        >
                                                                            <option value="">Select Country</option>
                                                                            {countries.map((country) => (
                                                                                <option key={country.id} value={country.id}>{country.name}</option>
                                                                            ))}
                                                                        </select>
                                                                        {touched.details?.bank_country_id && errors.details?.bank_country_id && (
                                                                            <div className="invalid-feedback">{errors.details.bank_country_id}</div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className="row">
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="bank_state_id" className="form-label">State</label>
                                                                        <select 
                                                                            id="bank_state_id"
                                                                            name="details.bank_state_id" 
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} 
                                                                            disabled={!values.details.bank_country_id || !isOwner} 
                                                                            value={values.details.bank_state_id} 
                                                                            className={`form-control ${touched.details?.bank_state_id && errors.details?.bank_state_id ? 'is-invalid' : ''}`}
                                                                        >
                                                                            <option value="">Select State</option>
                                                                            {bankStates.map((state) => (
                                                                                <option key={state.id} value={state.id}>{state.name}</option>
                                                                            ))}
                                                                        </select>
                                                                        {touched.details?.bank_state_id && errors.details?.bank_state_id && (
                                                                            <div className="invalid-feedback">{errors.details.bank_state_id}</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12">
                                                                <div className="form-group text-end">
                                                                    <button 
                                                                        type="submit" 
                                                                        className="btn btn-primary" 
                                                                        disabled={loading || isSubmitting || !isOwner}
                                                                    >
                                                                        {loading || isSubmitting ? 'Saving...' : 'Save Changes'}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Sidebar>
                </div>
            </div>
        </div>
    </Layout>
);
}
